import React, { useEffect, useRef, useState } from "react";
import { getPageContents } from "../../services/apiOtherlink";
import eyeoff from "../../assets/img/logo2 1.png"
import mobillogo from "../../assets/img/mobile-logo.png"
import search from "../../assets/img/sreach---icon.svg"
import bell from "../../assets/img/bell.svg"
import chat from "../../assets/img/chat.svg"
import userImg from "../../assets/img/user 1.svg"
import searchwhite from "../../assets/img/header/search.svg"
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const CommonPrivacy = () => {
    const navigate = useNavigate();
  const [privacyContent, setPrivacyContent] = useState('');
  useEffect(() => {
      fetchContent()
    }, [])
 
    const fetchContent = async () => {
        let content = await getPageContents();
       
         setPrivacyContent(content.privacyPolicy.template);
    
      }

  
  return (
   <div >
    <>
      <header className="header-top container-fluid d-flex align-items-center justify-content-center">

        
        <form className=" align-items-center justify-content-center" >
  <div className="input-group search-header-wrapper">
    
    <Link to='/' class="d-flex align-items-center">
          <button className="btn toggle-btn d-lg-none header-toggle">
            &#9776;
          </button>
          <span class="h5 mb-0">
            <img src={eyeoff} alt="Logo comp-logo" class="heder-logo me-3" />
          </span>
          <span class="h5 mb-0">
            <img src={mobillogo} alt="Mobile Logo" className="mobile-logo" />
          </span>

        </Link>
               
            
  </div>


  
</form>




        
        {/* </header> */}




      </header>
      
    </>
  <div className="p-5 mt-3">
    <div className="hd-breadcums">
    <h3 className="main-heading">Privacy Policy</h3>
  </div>
   <div className="succ-content" dangerouslySetInnerHTML={{ __html: privacyContent}} /> 

  <style>{`
        .tc { list-style: none; padding-left: 0; }
        .mt-3 { margin-top: 1rem; }
        .sub-t-c { margin-top: 0.25rem; }
        ul.tc li ol li {
    list-style: auto;
        margin-bottom: 10px;
}
        ul.tc ol {
    padding-left: 16px !important;
    margin-bottom: 0px;
}
      `}</style>
  </div>
</div>


  );
};
export default CommonPrivacy;